import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import ContactUsPage from "@/components/ContactUsPage";
import AdszieBanner from "@/components/ui/AdszieBanner";

const ContactUs = () => {
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    gsap.fromTo(
      modalRef.current,
      { y: "100%" },
      { y: "8%", duration: 1.2, ease: "power3.out" }
    );
  }, []);

  return (
    <div className="fixed inset-0 flex">
      <div className="absolute inset-0 bg-[#0d1821]/80 backdrop-blur-sm" />

      {/* bg image */}
      <div className="absolute h-full w-full bg-transparent flex justify-center">
        <div className="h-full bg-[#0d1821] w-full" />
      </div>

      {/* bg text */}
      <div className="absolute h-full w-full bg-transparent flex justify-center">
        <AdszieBanner />
      </div>

      {/* Drawer content */}
      <div
        ref={modalRef}
        className="relative flex items-center justify-center z-10 h-[92vh] md:h-[95vh] text-[#0d1821] bg-[#f5f5f5] p-4 w-full m-auto rounded-t-[90px]"
      >
        <ContactUsPage />
      </div>
    </div>
  );
};

export default ContactUs;
